import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ChangeLimitRequest } from 'src/app/models/account';
import * as firebase from 'firebase';

declare var $: any;

@Component({
  selector: 'app-change-limit',
  templateUrl: './change-limit.component.html',
  styleUrls: ['./change-limit.component.css']
})
export class ChangeLimitComponent implements OnInit {

  failMessage: string;
  isLoading = false;

  constructor(private router: Router,
    private authService: AuthenticationService) { }

  ngOnInit() {
    firebase.analytics().logEvent('profil_limit_page');
  }

  setLimit(limit: ChangeLimitRequest) {
    console.log('in');
    this.isLoading = true;
    // const data = new ChangeLimitRequest();
    // data.limit = limit;
    // data.isOn = true;
    // data.pin = '';
    this.authService.changeLimit(limit,
      resp => {
        this.isLoading = false;
        if (resp.alert.code === 200) {
          $('#success').modal('show');
          setTimeout(() => {
            $('#success').modal('hide');
            this.router.navigate(['/dashboard']);
          }, 2000);
        } else {
          this.failMessage = resp.alert.message;
          $('#fail').modal('show');
        }
      },
      err => {
        this.failMessage = err;
          $('#fail').modal('show');
      });
  }

  refresh(): void {
    location.reload();
  }
}
